export const attachmentPolicyHyperLinkText = "V6b";
export const attachmentPolicyInformationReadOnly = "W6b";
export default {attachmentPolicyHyperLinkText,attachmentPolicyInformationReadOnly};